import { Vector3, Web3DViewer } from '@technology/web3d';
import { CapabilityRegistryContainer } from '@trimble/web3d';
import { isPointVisibleInMap, updateFrustum } from './sync-source-helpers';

const DEFAULT_CAMERA_HEIGHT = 2000;

/**
 * Shared body for syncing any source into a map (top-down) pane.
 * Centers the map camera on `syncPosition` when the point is not visible
 * and updates the target frustum. Per-source SyncFns call this with their
 * own resolved position and orientation flag.
 */
export function applyToMap(
  targetPane: CapabilityRegistryContainer,
  targetViewer: Web3DViewer,
  sourceViewer: Web3DViewer,
  syncPosition: Vector3,
  propagateOrientation: boolean
): void {
  if (!isPointVisibleInMap(syncPosition, targetViewer)) {
    targetViewer.camera.position = new Vector3(
      syncPosition.x,
      syncPosition.y,
      targetViewer.camera.position.z !== 0
        ? targetViewer.camera.position.z
        : DEFAULT_CAMERA_HEIGHT
    );
  }

  updateFrustum(
    targetPane,
    syncPosition,
    propagateOrientation ? sourceViewer.camera.quaternion.toArray() : null,
    propagateOrientation ? sourceViewer.camera.fieldOfView : null
  );
}
